var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 41"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.75,
    fill: "#651F70",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12 25 4.586-4.586a2 2 0 0 1 2.828 0L24 25m-2-2 1.586-1.586a2 2 0 0 1 2.828 0L28 23m-6-6h.01M14 29h12a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2H14a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
  })));
};
export default SvgGallery;